<template>
  <BaseTab>
    <v-subheader>PARTICIPANTS IN ROOM</v-subheader>
    <v-list v-if="participants.length > 0">
      <v-list-item
        v-for="participant in participants"
        :key="participant.uuid"
      >

        <v-list-item-content>
          <v-list-item-title v-text="participant.name"></v-list-item-title>
        </v-list-item-content>

        <v-list-item-avatar :color="participant.avatar.color">
          <span class="white--text headline">{{ participant.avatar.initials }}</span>
        </v-list-item-avatar>
      </v-list-item>
    </v-list>
  </BaseTab>
</template>

<script>
import BaseTab from '@/components/base/BaseTab'
import { mapState } from 'vuex'

export default {
  name: 'Participants',

  data: () => ({
    allParticipants: []
  }),

  components: {
    BaseTab
  },

  computed: {
    ...mapState({
      participants: state => state.canvas.participants
    })
  }
}
</script>

<style lang="sass" scoped>

</style>
